import type { Command } from './types';

export const editCommands: Command[] = [
  {
    id: 'edit.undo',
    label: 'Undo',
    category: 'edit',
    execute: (ctx) => {
      ctx.doc.undo();
    },
  },
  {
    id: 'edit.redo',
    label: 'Redo',
    category: 'edit',
    execute: (ctx) => {
      ctx.doc.redo();
    },
  },
];
